<template>
    <header class="text-center mb-4">
        <h2 class="skin-page-heading">Financial Coaching</h2>
    </header>

    <div class="row">
        <div class="col-md-8 mx-auto">
            <p>
                Financial coaching is about informing and educating. The end goal is to empower you to make your own decisions without having to pay ongoing costs to support you.
            </p>
            <p>
                By being taught what you need to know, you can make better decisions by yourself in future. It is available to anyone and can be provided at any time, but it is especially good to understand the most complex decisions you may need to make. Given this, it can be ideal if you are near to, or at, your planned retirement date.
            </p>
            <p>
                Coaching works particularly well alongside free guidance tools like Guiide. When used together, they can provide everything you need if you are happy to make your own decisions, whilst significantly reducing your costs.
            </p>
            <p>
                Through the support of a coach who understands the difficulties and complexity of the retirement and pensions process, you can feel in control. A good financial coach will challenge you on your planning and help you fill in any gaps in your financial knowledge, to help you make the right decisions yourself.
            </p>


            <div class="row mb-2">
                <div class="col-md-8">
                    <p>
                        One coaching option is Dianne Sullivan. She is an IFA qualified financial coach with a wealth of experience in supporting people, including our users, with their retirement planning. She also uses Guiide with her clients, showing people how to make the best use out of it.
                    </p>
                </div>
                <div class="col-md-4 text-center">
                    <img src="/Content/images/dianne-sullivan-logo.png" alt="Dianne Sullivan - Money, Career and Life Coaching" width="180" class="mb3 img-fluid" />
                </div>
            </div>

            <p>
                You can see her in our pension basics video, or in a wealth of videos on more complex issues on her <a href="https://www.youtube.com/@DianneSullivan" target="_blank">YouTube channel</a>.
            </p>
            <p>
                There is some cost involved in coaching, but you can <a href="https://diannesullivan.as.me/schedule.php" target="_blank">book a free 30 minute session</a> to chat through what you are looking for at no cost, or obligation via. You can then arrange the right amount of sessions if you wish to do so.
            </p>
            <p>
                Disclaimer - to be clear, Guiide does not receive any referral fees from any coaching partners. We have some commercial relationships such as custom videos, but signposting these services to our users provides no commercial benefit to Guiide.
            </p>
        </div>
    </div>
</template>
